import React, { useEffect, useState } from "react";
import { Table, Button, Select, Tabs, Tag, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { FaEye } from "react-icons/fa";
// import moment from "moment";
import { getStates } from "../features/statecity/statecitySlice";
import { getUsers } from "../features/cutomers/customerSlice";
import { UploadOutlined, ExportOutlined } from "@ant-design/icons";
import ImagePopupModal from "../components/ImagePopupModal";

import {
  getTrainningSchdules,
  resetState,
} from "../features/trainning-schdule/trainningschduleSlice";
import { getBrands } from "../features/brand/brandSlice";
import { CSVLink } from "react-csv";

const Trainningschdule = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [vcData, setvcData] = useState([]);
  // const [selectedTab, setSelectedTab] = useState("9");
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [vtData, setvtData] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedVC, setselectedVC] = useState("");
  const [selectedVT, setSelectedVT] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [filteredTrainings, setFilteredTrainings] = useState([]); // Ensure it's an array
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  const statelistState = useSelector((state) => state.statecity.statelist);
  const vclistState = useSelector((state) => state.customer.customers);
  const classlistState = useSelector((state) => state.brand.brands);

  const handleImageClick = (images) => {
    console.log("Click Image ----");
    setSelectedImages(images);
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
    setSelectedImages([]);
  };

  useEffect(() => {
    dispatch(resetState());
    dispatch(getTrainningSchdules());
    dispatch(getStates());
    dispatch(getUsers());
    dispatch(getBrands());
  }, [dispatch]);

  const traininglist = useSelector(
    (state) => state.trainningschdule.trainningschdules || []
  );

  useEffect(() => {
    if (traininglist.length > 0 && !initialDataLoaded) {
      handleSubmit();
      setInitialDataLoaded(true);
    }
  }, [traininglist, initialDataLoaded]);

  const columns = [
    {
      dataIndex: "key",
      title: "Sr No",
      width: 10,
    },
    {
      dataIndex: "date",
      title: "Date",
      width: 20,
    },
    {
      dataIndex: "class",
      title: "Class",
      width: 20,
    },
    {
      dataIndex: "unit",
      title: "Unit",
      width: 20,
    },
    {
      dataIndex: "es_vs",
      title: "E/V Skills",
      width: 30,
    },
    {
      dataIndex: "topic_name",
      title: "Topic",
      width: 30,
    },
    {
      dataIndex: "subtopic_name",
      title: "Sub-Topic",
      width: 30,
    },
    {
      dataIndex: "district_name",
      title: "District Name",
      width: 30,
    },
    {
      dataIndex: "school_name",
      title: "School Name",
      width: 30,
    },
    {
      dataIndex: "submitted_by",
      title: "Submitted By",
      width: 30,
    },
    {
      dataIndex: "daily_diary",
      title: "Daily Diary View",
      width: 30,
      render: (text, record) => (
        <Button
          className="uploade_doc"
          shape="round"
          icon={<UploadOutlined />}
          size={5}
          onClick={() => handleImageClick(record.uploaded_doc)}
        >
          View{" "}
        </Button>
      ),
    },
  ];

  const handleStateChange = (value) => {
    const vcfilterData = vclistState.filter(
      (customer) => customer.state === value
    );
    setvcData(vcfilterData);
    setSelectedState(value);
  };

  const handleVcChange = (value) => {
    const vtfilterData = vclistState.filter(
      (customer) => customer.vcuser_id === value
    );
    setvtData(vtfilterData);
    setselectedVC(value);
  };

  const handleVTChange = (value) => {
    setSelectedVT(value);
  };

  const handleClassChange = (value) => {
    setSelectedClass(value);
  };

  const handleSubmit = () => {
    const filteredData = traininglist.filter((trainning) => {
      const matchesState = selectedState
        ? trainning.userDetails.state === selectedState
        : true;
      const matchesVT = selectedVT
        ? trainning.userDetails._id === selectedVT
        : true;
      const matchesClass = selectedClass
        ? trainning.class === selectedClass
        : true;

      return matchesState && matchesVT && matchesClass;
    });

    setFilteredTrainings(filteredData);
  };

  const handleClear = () => {
    form.resetFields();
    setSelectedState("");
    setselectedVC("");
    setSelectedVT("");
    setSelectedClass("");
    setFilteredTrainings(traininglist);
    setvcData([]);
    setvtData([]);
  };

  const data1 = Array.isArray(filteredTrainings)
    ? filteredTrainings.map((trainning, index) => {
        const extractUrls = (images) =>
          images.map((image) => ({ url: image.url }));

        return {
          key: index + 1,
          date: trainning.date,
          class: trainning.class,
          unit: trainning.unit || "N/A",
          es_vs: trainning.es_vs || "N/A",
          topic_name: trainning.topic_name || "N/A",
          subtopic_name: trainning.subtopic_name || "N/A",
          state_name: trainning.userDetails.state || "N/A",
          district_name: trainning.userDetails.district || "N/A",
          school_name: trainning.userDetails.school_name || "N/A",
          submitted_by: trainning.userDetails.name || "N/A",
          complete_task: trainning.complete_task ? (
            <Tag color="green"> Yes </Tag>
          ) : (
            <Tag color="red"> No </Tag>
          ),
          daily_diary: "View",
          uploaded_doc: [...extractUrls(trainning.image_upload || [])],
        };
      })
    : [];

  const csvHeaders = [
    { label: "S. No", key: "key" },
    { label: "Date", key: "date" },
    { label: "Class", key: "class" },
    { label: "Unit", key: "unit" },
    { label: "Skills", key: "es_vs" },
    { label: "Topic Name", key: "topic_name" },
    { label: "Subtopic Name", key: "subtopic_name" },
    { label: "Submitted By", key: "submitted_by" },
  ];

  return (
    <div>
      <h3 className="mb-4 title">Trainning Schdules</h3>
      <div
        style={{
          marginBottom: 16,
          backgroundColor: "#ffffff",
          border: "1px solid #eef2f6",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
        }}
      >
        <Form form={form} layout="inline" onFinish={handleSubmit}>
          <Form.Item
            name="state_name"
            rules={[
              {
                required: true,
                message: "Please Select State!",
              },
            ]}
          >
            <Select
              style={{ width: 160, marginRight: 16 }}
              placeholder="Select State"
              onChange={handleStateChange}
            >
              {statelistState.map((i, j) => (
                <Select.Option key={j} value={i.state}>
                  {i.state_name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="vc_name"
            rules={[
              {
                required: true,
                message: "Please Select VC!",
              },
            ]}
          >
            <Select
              style={{ width: 160, marginRight: 16 }}
              placeholder="Select VC"
              onChange={handleVcChange}
            >
              {vcData
                .filter((item) => item.role === "vc")
                .map((item) => (
                  <Select.Option key={item._id} value={item._id}>
                    {item.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="vt_name"
            rules={[
              {
                required: true,
                message: "Please Select VT!",
              },
            ]}
          >
            <Select
              style={{ width: 160, marginRight: 16 }}
              placeholder="Select VT"
              onChange={handleVTChange}
            >
              {vtData
                .filter((item) => item.role === "vt")
                .map((item, i) => (
                  <Select.Option key={item._id} value={item._id}>
                    {item.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>

          <Form.Item name="class_name">
            <Select
              style={{ width: 160 }}
              placeholder="Select Class"
              onChange={handleClassChange}
            >
              {classlistState.map((cls, index) => (
                <Select.Option key={index} value={cls.title}>
                  {cls.title}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item>
            <Button
              style={{ marginRight: 20 }}
              type="primary"
              htmlType="submit"
            >
              <FaEye />
              View
            </Button>
          </Form.Item>

          <Form.Item>
            <Button type="default" onClick={handleClear}>
              Clear
            </Button>
          </Form.Item>
        </Form>
      </div>

      <CSVLink
        data={data1}
        headers={csvHeaders}
        filename={`trainningschdule_${new Date().toISOString()}.csv`}
      >
        <Button type="primary" className="exportcsv">
          <ExportOutlined /> Export to CSV
        </Button>
      </CSVLink>

      <Table
        style={{ marginBottom: 16, padding: "20px" }}
        className="custom-table"
        columns={columns}
        dataSource={data1}
      />
      <ImagePopupModal
        visible={modalVisible}
        images={selectedImages}
        onClose={closeModal}
      />
    </div>
  );
};

export default Trainningschdule;
